import { useState } from 'react';
import { useToast } from '@stepstone-genesis/components';
import { sendMyaPatchRequest } from 'modules/hub/components/AMAChat/AskMeAnything/Conversation/sendMyaPatchRequest';
import { helpers } from 'modules/hub/components/AMAChat/utils/helpers';
import labels from 'modules/hub/components/AMAChat/constants/labels/ama';
export const useCsat = ({ lang, messageId, conversationId, sessionToken, onChatEnd, }) => {
    const { add, remove } = useToast();
    const [response, setResponse] = useState(undefined);
    const feedbackToastId = `feedback-thankyou-csat-${helpers.rand()}`;
    const onToastDismiss = () => {
        remove(feedbackToastId);
    };
    const showFeedbackToast = () => {
        add({
            content: labels[lang].feedbackThankYouMessage,
            placement: 'bottom-right',
            variant: 'positive',
            duration: 2000,
            onDismiss: onToastDismiss,
            id: feedbackToastId,
        });
    };
    const sendCsatData = async (csatRating) => {
        if (messageId) {
            const { status } = await sendMyaPatchRequest({
                conversationId,
                body: {
                    misc_payload: { csat: csatRating },
                },
                messageId,
                sessionToken,
            });
            if (status === 200) {
                showFeedbackToast();
            }
            else {
                setResponse(undefined);
            }
        }
    };
    const handleCsatClick = async ({ id }) => {
        setResponse(id);
        await sendCsatData(id);
        // todo: timer, to let the user see their choice was accepted
        onChatEnd?.();
    };
    return { response, handleCsatClick };
};
